<template>
  <v-dialog :value="showDialog" persistent :width="width" :min-height="height">
    <v-card style="padding-top: 10px">
      <v-card-text>
        <v-expansion-panels
          v-model="panel"
          class="margin-right-5px margin-top-5px"
          multiple
        >
          <v-expansion-panel>
            <v-expansion-panel-header style=""
              >eigene Fahrzeuge</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-subheader>
                Wähle aus, welches der aufgelisteten Fahrzeuge du verwendest
              </v-subheader>
              <div v-for="(t, i) in ownVehicles" :key="i">
                <v-switch
                  v-if="isNonOepvVehicle(t.vehicleId)"
                  :input-value="t.isUsed"
                  color="primary"
                  @change="change($event, t.vehicleId)"
                  :label="getVehicleLabelById(t.vehicleId)"
                  hide-details
                ></v-switch>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header style=""
              >eigene Fahrzeuge (inkl. öpv)</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-subheader>
                Wähle aus, welches der aufgelisteten Fahrzeuge du verwendest
              </v-subheader>
              <div v-for="(t, i) in ownVehiclesSpec" :key="i">
                <v-switch
                  v-if="isOepvVehicle(t.ownVehicleId)"
                  :input-value="t.isUsed"
                  color="primary"
                  @change="changeVehiclesSpec($event, t.ownVehicleId)"
                  :label="getOepvVehicleLabelById(t.ownVehicleId)"
                  hide-details
                ></v-switch>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header style="">ÖPV</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-subheader> ÖPV-Einstellungen </v-subheader>
              <div>
                Welche Bahncard besitzt du?
                <v-select
                  :items="[0, 25, 50, 100]"
                  @change="changeBahncard($event)"
                  :value="bahncardPercent.value"
                ></v-select>
              </div>
              <div>
                Nutzt du das Deutschlandticket?
                <v-switch
                  :input-value="deutschlandticketUsed.value"
                  color="primary"
                  @change="changeDeutschlandticket($event)"
                  hide-details
                ></v-switch>
              </div>
              <div style="margin-top: 10px">
                Maximale Umstiege mit dem ÖPV
                <v-text-field
                  :value="maxOepvChanges.value"
                  @change="changeOepvChanges($event)"
                  maxlength="3"
                  :rules="[required, numberRule]"
                  counter
                ></v-text-field>
              </div>
              <v-expansion-panel>
                <v-expansion-panel-header style=""
                  >Erweiterte Einstellungen</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-subheader
                    >Maximale Umstiege bei max. ÖPV-Distanz</v-subheader
                  >
                  <div class="flex-box-left-aligned-horizontal">
                    <div style="margin-top: 10px">
                      25 km
                      <v-text-field
                        :value="maxOepvChanges25Km.value"
                        @change="changeOepvChanges($event, 25)"
                        maxlength="3"
                        :rules="[required, numberRule]"
                        counter
                      ></v-text-field>
                    </div>
                    <div style="margin-top: 10px">
                      50 km
                      <v-text-field
                        :value="maxOepvChanges50Km.value"
                        @change="changeOepvChanges($event, 50)"
                        maxlength="3"
                        :rules="[required, numberRule]"
                        counter
                      ></v-text-field>
                    </div>
                    <div style="margin-top: 10px">
                      100 km
                      <v-text-field
                        :value="maxOepvChanges100Km.value"
                        @change="changeOepvChanges($event, 100)"
                        maxlength="3"
                        :rules="[required, numberRule]"
                        counter
                      ></v-text-field>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- <v-expansion-panels class="margin-right-5px margin-top-5px" multiple>
          <v-expansion-panel v-for="(t, i) in transportGroups" :key="i">
            <v-expansion-panel-header style="">{{
              t.name
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-subheader
                >Aufschlag für Parksuchzeit und Zielerreichung in
                Minuten</v-subheader
              >
              {{ t.transports }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="saveSettings()">speichern</v-btn>
        <v-btn color="secondary" @click="closeDialog()">abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import { useConfigStore } from "../store/config-store";
import { useAuthStore } from "../store/auth-store";

import { storeToRefs } from "pinia";
import { reversedRouteModesOEPV, ownVehiclesMapping } from "../ui-mappings";
import { UserProfileSettings } from "../cr-userprofile-api-client/src/index";

export default Vue.extend({
  name: "SettingsDialog",
  components: {},

  props: {
    showDialogVal: { default: false, type: Boolean },
    showDialogValChanged: { type: Function },
    width: { default: "auto", type: String },
    height: { default: "500px", type: String },
  },

  data: () => ({
    required: (value) => !!value || "Erforderlich.",
    numberRule: (value) => {
      const pattern = /^[0-9]+$/;
      return pattern.test(value) || "Ungültige Zahl.";
    },
    // email: ref(""),
    panel: [0],
    showDialogLoc: false,
    items: [{ title: "Einstellungen" }],
  }),
  watch: {},
  mounted() {
    useConfigStore().fetchTransportGroups();
  },
  computed: {
    bahncardPercent() {
      // console.log(
      //   "bahncardPercent=",
      //   storeToRefs(useAuthStore()).bahncardPercent
      // );

      return storeToRefs(useAuthStore()).bahncardPercent;
    },
    maxOepvChanges() {
      return storeToRefs(useAuthStore()).maxOepvChanges;
    },
    maxOepvChanges25Km() {
      return storeToRefs(useAuthStore()).maxOepvChanges25Km;
    },
    maxOepvChanges50Km() {
      return storeToRefs(useAuthStore()).maxOepvChanges50Km;
    },
    maxOepvChanges100Km() {
      return storeToRefs(useAuthStore()).maxOepvChanges100Km;
    },
    deutschlandticketUsed() {
      console.log(
        "deutschlandticketUsed=",
        storeToRefs(useAuthStore()).deutschlandticketUsed
      );

      return storeToRefs(useAuthStore()).deutschlandticketUsed;
    },

    showDialog() {
      // console.log(this.showDialogVal , this.showDialogLoc)
      if (
        this.showDialogLoc !== undefined &&
        this.showDialogVal !== undefined
      ) {
        return this.showDialogVal || this.showDialogLoc;
      } else {
        return false;
      }
    },

    ownVehiclesSpec() {
      // return [
      //   { vehicleId: "bicycle", isUsed: true },
      //   { vehicleId: "car", isUsed: false },
      // ];
      // console.log("storeToRefs(useConfigStore()).transportGroups=",storeToRefs(useConfigStore()).transportGroups)
      if (
        !storeToRefs(useConfigStore()).vehiclesSpec.value ||
        storeToRefs(useConfigStore()).vehiclesSpec.value.length === 0
      ) {
        return [];
      }
      const vehiclesSpec = storeToRefs(useConfigStore()).vehiclesSpec.value;

      // console.log("ownVehicles-vehicles=", vehiclesSpec);
      return vehiclesSpec;
    },
    ownVehicles() {
      // return [
      //   { vehicleId: "bicycle", isUsed: true },
      //   { vehicleId: "car", isUsed: false },
      // ];
      // console.log("storeToRefs(useConfigStore()).transportGroups=",storeToRefs(useConfigStore()).transportGroups)
      if (
        !storeToRefs(useConfigStore()).vehicles.value ||
        storeToRefs(useConfigStore()).vehicles.value.length === 0
      ) {
        return [];
      }
      const vehicles = storeToRefs(useConfigStore()).vehicles.value;

      // console.log("ownVehicles-vehicles=", vehicles);
      return vehicles;
    },

    transportGroups() {
      // console.log("storeToRefs(useConfigStore()).transportGroups=",storeToRefs(useConfigStore()).transportGroups)
      if (
        storeToRefs(useConfigStore()).transportGroupsBuilt.value.length === 0
      ) {
        return [];
      }
      const transportGroupsBuilt = storeToRefs(useConfigStore())
        .transportGroupsBuilt.value;
      // compute the actual sections
      const bikesGroup = transportGroupsBuilt.find(
        (t) => t.id === "modal_only_bikes"
      );
      const bikesharingGroup = bikesGroup.transports.filter(
        (b) =>
          b.transportType === "bikesharing" ||
          b.transportType === "eBikesharing"
      );
      const carGroup = transportGroupsBuilt.find(
        (t) => t.id === "modal_only_cars"
      );
      const carsharingGroup = carGroup.transports.filter(
        (b) =>
          b.transportType === "carsharing" || b.transportType === "eCarsharing"
      );
      return [
        { transports: bikesharingGroup, name: "bikesharing" },
        { transports: carsharingGroup, name: "carsharing" },
      ];
    },
  },

  async created() {},
  watch: {},
  destroyed() {
    this.showDialogValChanged(false);
  },
  methods: {
    isOepvVehicle(vehicleId) {
      if (Object.keys(reversedRouteModesOEPV).includes(vehicleId)) {
        return true;
      } else {
        return false;
      }
    },
    isNonOepvVehicle(vehicleId) {
      if (Object.keys(ownVehiclesMapping).includes(vehicleId)) {
        return true;
      } else {
        return false;
      }
    },
    getVehicleLabelById(vehicleId) {
      if (Object.keys(ownVehiclesMapping).includes(vehicleId)) {
        return ownVehiclesMapping[vehicleId].name;
      } else {
        return vehicleId;
      }
    },
    getOepvVehicleLabelById(vehicleId) {
      if (Object.keys(reversedRouteModesOEPV).includes(vehicleId)) {
        return reversedRouteModesOEPV[vehicleId].name;
      } else {
        return vehicleId;
      }
    },
    saveSettings() {
      const userId = storeToRefs(useAuthStore()).userId.value;
      useConfigStore().saveUsageOfVehicleSpecRemotely(userId);
      useConfigStore().saveUsageOfVehicleRemotely(userId);
      this.showDialogValChanged(false);
    },
    changeOepvChanges(val, distance = null) {
      const userId = storeToRefs(useAuthStore()).userId;
      let valInt;
      let userData = new UserProfileSettings();
      userData.userId = userId.value;

      valInt = Number.parseInt(val);

      if (valInt === undefined) {
        return;
      }

      if (distance === 25) {
        userData.maxOepvChanges25Km = valInt;
      } else if (distance === 50) {
        userData.maxOepvChanges50Km = valInt;
      } else if (distance === 100) {
        userData.maxOepvChanges100Km = valInt;
      } else {
        userData.maxOepvChanges = valInt;
      }
      useAuthStore().modifyUserData(userData);
    },
    changeDeutschlandticket(val) {
      const userId = storeToRefs(useAuthStore()).userId;
      const userData = { deutschlandticketUsed: val, userId: userId.value };
      useAuthStore().modifyUserData(userData);
    },
    changeBahncard(val) {
      const userId = storeToRefs(useAuthStore()).userId;
      const userData = { bahncardPercent: val, userId: userId.value };
      useAuthStore().modifyUserData(userData);
    },
    change(val, vehicleId) {
      // as here only own vehicles are changed, 'default' provider is used
      useConfigStore().changeUsageOfVehicleLocally(val, vehicleId, "default");
    },
    changeVehiclesSpec(val, vehicleId) {
      // as here only own vehicles are changed, 'default' provider is used
      useConfigStore().changeUsageOfVehicleSpecLocally(val, vehicleId);
    },
    closeDialog() {
      this.showDialogValChanged(false);
      this.showDialogLoc = false;
    },
  },
});
</script>
<style scoped>
</style>
   
